import React, { createContext, useState, useContext } from 'react';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
  const [alertMessages, setAlerts] = useState([]);
  const [maintenanceMessages, setMaintenance] = useState([]);

  return (
    <AlertContext.Provider value={{ alertMessages, setAlerts, maintenanceMessages, setMaintenance }}>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlerts = () => useContext(AlertContext);